export default __webpack_public_path__ + "static/media/frame-card-grandchief.b0d25462.png";